export enum UserContext {
	MY_CPG = 'MY_CPG',
	ARC = 'ARC',
	MINIMAP = 'MINIMAP',
}

export enum EmployeeContext {
	InstitutionEmployee = 'InstitutionEmployee',
	InstitutionAdmin = 'InstitutionAdmin',
	GroupAdmin = 'GroupAdmin',
	Participant = 'Participant',
}

export interface ExternalLinkState {
	renderModal: boolean;
	linkUrl: string;
	linkInnerHtml: string;
}

export enum NavigationContext {
	None = 'None',
	Institution = 'Institution',
	Diocese = 'Diocese',
	DioceseInstitution = 'DioceseInstitution',
	BillingAccount = 'BillingAccount',
	GroupAdmin =  'GroupAdmin',
}

export interface SystemContext {
	base_cycle_date : string,
	current_statement_date : string,	
}

export interface AppContext {
	userContext: UserContext;
	employeeContext: EmployeeContext;
	externalLinkState: ExternalLinkState;
	userNavigationContext: NavigationContext;
	systemContext: SystemContext;
}

export enum AppContextActions {
	SET_USER_CONTEXT = 'SET_USER_CONTEXT',
	SET_EXTERNAL_LINK_STATE = 'SET_EXTERNAL_LINK_STATE',
	SET_EMPLOYEE_CONTEXT = 'SET_EMPLOYEE_CONTEXT',
	SET_NAVIGATION_CONTEXT = 'SET_NAVIGATION_CONTEXT',
	SET_SYSTEM_CONTEXT = 'SET_SYSTEM_CONTEXT',
}
